module.exports = __webpack_public_path__ + "img/burst-left.130e9f46.png";